






































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import Header from "@/components/header.vue";
import LeftNav from "../components/left-nav.vue";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import {
  GetExamList,
  GetBanjiOptions,
  EditExam,
  DelExam,
  GetPaperOptions,
  GetExamPaperList,
} from "@/request/common";
@Component({
  components: {
    Header,
    LeftNav,
  },
})
export default class Name extends mixins(listMixin) {
  private ifShowEdit: any = false;
  private editData: any = {};
  private zhuangtais: any = ["考试中", "待考", "已结束"];
  private banjis: any = [];
  private data: any = [];
  private papers: any = [];
  private disabledStartDate: any = this.beginDate();
  private disabledEndDate: any = this.endDate();
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private get user() {
    return this.$store.state.user;
  }

  private goStatistic(item: any) {
    this.$router.push({
      path: "/main/teacher/exam-statistic",
      query: {
        id: item.exam_id,
      },
    });
  }
  private goResult(item: any) {
    this.$router.push({
      path: "/main/teacher/exam-result",
      query: {
        id: item.exam_id,
      },
    });
  }
  private deleteOne(item: any) {
    this.$confirm("您确定要删除该数据么？", "删除", {
      customClass: "commonConfirm",
      confirmButtonClass: "iconfont icon-anniu4 confirmSure",
      cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
    })
      .then(() => {
        const loading = this.$loading({
          lock: true,
          text: "加载中……",
          spinner: "el-icon-loading",
          customClass: "loadClass",
          background: "rgba(255, 255, 255, 0.7)",
        });
        const params: any = {
          data: {
            exam_id: item.exam_id,
          },
        };
        DelExam(this, params, loading)
          .then((res: any) => {
            loading.close();
            this.$message.success("删除成功");
            if (this.data.length === 1 && this.filters.current_page !== 1) {
              this.filters.current_page--;
            }
            this.getList();
          })
          .catch(() => {
            loading.close();
          });
      })
      .catch((e) => {
        console.log("取消了");
      });
  }
  private beginDate() {
    const self = this;
    return {
      disabledDate(time: any) {
        if (self.editData["结束时间"]) {
          return (
            time.getTime() > new Date(self.editData["结束时间"]).getTime() ||
            time.getTime() < Date.now() - 8.64e7
          );
        } else {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
    };
  }
  private endDate() {
    const self = this;
    return {
      disabledDate(time: any) {
        if (self.editData["开始时间"]) {
          const startTime = new Date(self.editData["开始时间"]);
          return (
            new Date(self.editData["开始时间"]).getTime() > time.getTime() ||
            time.getTime() < Date.now() - 8.64e7
          );
        } else {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
    };
  }
  private openEdit(item: any) {
    if (item) {
      this.editData = JSON.parse(JSON.stringify(item));
    } else {
      this.editData = {};
    }
    this.ifShowEdit = true;
  }
  private editSure() {
    if (!this.editData["名称"]) {
      this.$message.warning("请输入试卷名称");
      return;
    }
    if (!this.editData["paper_id"]) {
      this.$message.warning("请选择关联试卷");
      return;
    }
    if (!this.editData["banji_id"]) {
      this.$message.warning("请选择关联班级");
      return;
    }
    if (!this.editData["开始时间"]) {
      this.$message.warning("请选择开始时间");
      return;
    }
    if (!this.editData["结束时间"]) {
      this.$message.warning("请选择结束时间");
      return;
    }
    if (!this.editData["时长"]) {
      this.$message.warning("输入考试时长");
      return;
    }
    if (this.editData["开始时间"]) {
      if (
        new Date(this.editData["开始时间"]).getTime() < new Date().getTime()
      ) {
        this.$message.warning("开始时间要大于当前时间");
        return;
      }
    }
    if (this.editData["开始时间"] && this.editData["结束时间"]) {
      if (
        new Date(this.editData["结束时间"]).getTime() <
        new Date(this.editData["开始时间"]).getTime()
      ) {
        this.$message.warning("结束时间要大于开始时间");
        return;
      }
    }
    if (this.editData["考试时长"]) {
      if (!/^[1-9]\d*$/.test(this.editData["考试时长"])) {
        this.$message.warning("考试时长只能输入正整数");
        return;
      }
    }
    const min =
      (new Date(this.editData["结束时间"]).getTime() -
        new Date(this.editData["开始时间"]).getTime()) /
      60000;
    if (this.editData["时长"] > min) {
      this.$message.warning("考试时长不能大于结束时间-开始时间");
      return;
    }
    const params: any = {
      exam_id: this.editData.exam_id,
      名称: this.editData["名称"],
      类型: "正式",
      开始时间: this.editData["开始时间"],
      结束时间: this.editData["结束时间"],
      banji_id: this.editData.banji_id,
      paper_id: this.editData.paper_id,
      时长: this.editData["时长"],
    };
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    EditExam(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.$message.success(`${this.editData.exam_id ? "编辑" : "新建"}成功`);
        this.ifShowEdit = false;
        this.getList();
      })
      .catch(() => {
        loading.close();
      });
  }

  getList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params = {
      search: this.filters.search,
      banji_id: this.filters["班级"],
      状态: this.filters["状态"],
      order_key: this.filters.sort_field,
      order_value: this.filters.sort_value,
      current_page: this.filters.current_page,
      page_count: this.filters.page_count,
    };
    localStorage.setItem("examListFilter", JSON.stringify(this.filters));
    GetExamList(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.data = res.data;
        this.filters.total_count = res.total_count;
        this.filters.total_page = res.total_page;
        if (this.data.length > 0) {
          this.ifShowEmpty = false;
        } else {
          this.ifShowEmpty = true;
        }
      })
      .catch(() => {
        loading.close();
      });
  }
  private getBanjis() {
    GetBanjiOptions(this).then((res: any) => {
      this.banjis = res;
    });
  }
  private getPapers() {
    // GetPaperOptions(this).then((res: any) => {
    //   this.papers = res;
    // });
    const params: any = {
      current_page: 1,
      order_key: "update_time",
      order_value: "-1",
      page_count: 0,
      search: "",
    };
    GetExamPaperList(this, params).then((res: any) => {
      this.papers = res;
    });
  }
  mounted() {
    this.filters.sort_field = "update_time";
    if (localStorage.getItem("examListFilter")) {
      this.filters = JSON.parse(localStorage.getItem("examListFilter") as any);
    }
    this.getList();
    this.getBanjis();
    this.getPapers();
  }
}
